import cn from 'classnames';
import React, { useMemo } from 'react';

import placeholderImageDark from '../../assets/media/img-placeholder-dark.png';
import placeholderImage from '../../assets/media/img-placeholder.png';
import { useAccessibility } from '../../contexts/AccessibilityContext';
import { AccessibilityModeEnum, ThemeEnum } from '../../utils/enums';
import { ImageProps } from './Image.types';

import './image.scss';

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  inverse,
  showPlaceholderOnEnhanced = true,
  className = '',
  ...props
}) => {
  const { settings } = useAccessibility();

  const showPlaceHolder = useMemo(
    () => settings.mode === AccessibilityModeEnum.Enhanced && showPlaceholderOnEnhanced,
    [settings.mode, showPlaceholderOnEnhanced]
  );

  const imageSrc = useMemo(() => {
    const placeholder =
      settings.theme === ThemeEnum.Dark
        ? inverse
          ? placeholderImage
          : placeholderImageDark
        : inverse
          ? placeholderImageDark
          : placeholderImage;

    return showPlaceHolder ? placeholder : src;
  }, [src, settings.theme, showPlaceHolder]);

  const imgClassName = cn('image', className, { placeholder: showPlaceHolder });

  return <img alt={alt} src={imageSrc} className={imgClassName} {...props} />;
};

export default Image;
